// extracted by mini-css-extract-plugin
export default {"selectorLoc":"HxfStockLocationForm_selectorLoc__8wHau","textModeLocationContainer":"HxfStockLocationForm_textModeLocationContainer__P+Zcl"};